import axios from "axios";
// Get User with API
export let GetUserData = async (token) => {
    let url = process.env.REACT_APP_ADMIN_API_URL + `/users/getAuthenticate`
    let jwt = token;
  try {
    const response = await axios.post(
        url,
        {
          "cors": true
           },
       {
        headers: {
            'Authorization': 'Bearer '+jwt, 
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
    return response.data.user

  } catch (error) {
      console.log(error)
      sessionStorage.removeItem('userSelect');
    throw error;
  }
};